import Button from '../ui/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { TopChannels, TopFiles, TopUsers } from '../../types/AppTypes';

interface PROPS {
  title: string;
  titleClass: string;
  csvData: TopFiles[] | TopChannels[] | TopUsers[];
  csvHeaders: string[];
}

const TableTitle = ({ title, titleClass, csvData, csvHeaders }: PROPS): JSX.Element => {
  const generateCsv = (arr: TopFiles[] | TopChannels[] | TopUsers[]) => {
    let csv = '';
    arr.forEach((item, i: number) => {
      const keysSize = Object.keys(item).length;
      let keysCount = 0;
      //get headers from first item.
      if (i === 0) {
        // eslint-disable-next-line
        for (let key in item) {
          //if not last header add comma else add new line
          csv += csvHeaders[keysCount] + (keysCount + 1 < keysSize ? ',' : '\r\n');
          keysCount++;
        }
        keysCount = 0;
      }
      for (let key in item) {
        csv += item[key] + (keysCount + 1 < keysSize ? ',' : '\r\n');
        keysCount++;
      }
    });
    return csv;
  };

  const downloadCsv = (csvString: string) => {
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${title}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
      <h4 className={titleClass} style={{ flex: 2, marginBottom: 0 }}>
        {title}
      </h4>
      <Button type="transparent" style={{ color: '#1E6E42' }} onClick={() => downloadCsv(generateCsv(csvData))}>
        <FontAwesomeIcon icon={faFileExcel} size="2x" />
      </Button>
    </div>
  );
};

export default TableTitle;
